import {ReactComponent as WarningIcon} from './warning.svg'

function Warning() {
  return <WarningIcon />
}

export default Warning
